const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
//@constants
const actionTypes = require('constants/actionTypes');
const { OVERDRAFT_LOAN_STANDARD, OVERDRAFT_LOAN_SUBTYPE, OVERDRAFT_LOAN_TYPE, OVERDRAFT_CANCEL_OVERDRAFT } = require('constants/index');
const { formatText } = require('core/i18n').i18n;

const cancelPregrantedCreditRequest = () => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_REQUEST
});

const cancelPregrantedCreditSuccess = data => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_SUCCESS,
    payload: {
        data
    }
});

const cancelPregrantedCreditFailure = error => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_FAILURE,
    payload: {
        error
    }
});

const clear = () => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_CLEAR
});
const setPregrantedCheckBox = () => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_CHECK
});
const cancelPregrantedCreditInitSuccess = response => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_INIT_SUCCESS,
    payload: {
        response
    }
});
const cancelPregrantedCreditInitFailure = error => ({
    type: actionTypes.CREDITS_CANCEL_PREGRANTED_INIT_FAILURE,
    payload: {
        error
    }
});
const cancelPregrantedCredit = (accountId) => (dispatch, getState) => {
    const immCreditCancelPregranted = getState().creditsCancelPregranted
    const operationProcessId = immCreditCancelPregranted.get('operationProcessId');
    const callback = (dispatch, getState, dataToken) => {
        const immAccount = getState().creditsPregranted.getIn(['byId', accountId]);

        const params = {
            header: {
                version: 2,
            },
            query: {
                tokenFirma: dataToken,
                operationProcessId,
                acceptanceText: formatText('creditCancel-checkBoxText'),
                datosConexion: {
                    contrato: {
                        numerodecontrato: immAccount.get('contractNumber'),
                        producto: immAccount.get('product')
                    }
                },
                fecIniVigencia: immAccount.getIn(['details', 'startingDate']),
                fecha: immAccount.getIn(['details', 'originalDate']),
                fecFinVigencia: immAccount.getIn(['details', 'originalDate']),
                timestampAlta: immAccount.getIn(['details', 'effectiveDate']),
                horaModif: immAccount.getIn(['details', 'hour']),
                codMoneda: immAccount.getIn(['available', 'currency']),
                contrato: {
                    numerodecontrato: immAccount.get('contractNumber'),
                    producto: immAccount.get('product')
                },
                subGrupoCtaContab: immAccount.get('newProduct')
            }
        };
        dispatch(cancelPregrantedCreditRequest());
        APIPost(dispatch, apiURLBuilder.getURL('pregrantedCreditCancel'), params)
            .then(response => dispatch(cancelPregrantedCreditSuccess(response)))
            .catch(error => dispatch(cancelPregrantedCreditFailure(error)));
    };

    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

const cancelPregrantedCreditInit = (accountId) => (dispatch, getState) => {
    const immAccount = getState().creditsPregranted.getIn(['byId', accountId]);
    const account = immAccount.get('iban');
    const contractNumberAccount = immAccount.get('newContractNumber');

    const params = {
        query: {
            account,
            product: {
                standard: OVERDRAFT_LOAN_STANDARD,
                subType: OVERDRAFT_LOAN_SUBTYPE,
                type: OVERDRAFT_LOAN_TYPE
            },
            contractNumberAccount,
            processType: OVERDRAFT_CANCEL_OVERDRAFT

        }
    };

    APIPost(dispatch, apiURLBuilder.getURL('pregrantedCreditCancelInit'), params)
        .then(response => dispatch(cancelPregrantedCreditInitSuccess(response)))
        .catch(error => dispatch(cancelPregrantedCreditInitFailure(error)));

}
const setCheckBox = (accountId) => (dispatch, getState) => {

    const immCreditCancelPregranted = getState().creditsCancelPregranted
    const initCall = immCreditCancelPregranted.get('initCall');

    !initCall && dispatch(cancelPregrantedCreditInit(accountId));
    dispatch(setPregrantedCheckBox());

}

module.exports = {
    cancelPregrantedCredit,
    clear,
    setCheckBox
};
